// ═══════════════════════════════════════════════════════════════
// FeatureLock — écran "verrouillé + teaser" pour le freemium (#5)
// Affiché à la place d'une feature premium quand l'utilisateur n'a
// pas le palier requis. CTA → page abonnement.
// ═══════════════════════════════════════════════════════════════

import React from 'react';
import { Lock, Sparkles, ArrowRight } from 'lucide-react';

const FEATURES = {
    studio: {
        title: 'ITRIIA Studio',
        line: 'Génération d\'images et de voix premium.',
        perks: ['Studio Images (modèles premium)', 'Studio Voice (TTS / clonage)', 'Export vers tes projets'],
    },
    zk: {
        title: 'Coffre-fort chiffré',
        line: 'Sanctuaire zero-knowledge pour tes contenus sensibles.',
        perks: ['Chiffrement bout-en-bout', 'Le serveur ne voit jamais tes clés', 'TOTP + phrase de récupération'],
    },
    connectors: {
        title: 'Connecteurs',
        line: 'Branche tes outils et automatise tes flux.',
        perks: ['Connecteurs site, mail, etc.', 'Agents de publication', 'Invocation depuis le chat'],
    },
    voice: {
        title: 'Studio Voice',
        line: 'Transcription et synthèse vocale.',
        perks: ['Transcription audio', 'Résumés vocaux', 'Réécriture'],
    },
    documents: {
        title: 'Documents',
        line: 'Usine à conversion souveraine pour tes fichiers.',
        perks: ['OCR PDF scanné → PDF cherchable', 'Extraction texte locale (ocrmypdf)', 'Extensible à d\'autres formats'],
    },
};

export default function FeatureLock({ feature = 'studio', onUpgrade }) {
    const f = FEATURES[feature] || FEATURES.studio;

    return (
        <div style={{ height: '100%', overflow: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px' }}>
            <div style={{
                maxWidth: 460, width: '100%', textAlign: 'center',
                background: 'var(--card-bg)', border: '1px solid var(--card-border)',
                borderRadius: 18, padding: '40px 34px', boxShadow: 'var(--shadow-lg)',
            }}>
                <div style={{
                    width: 64, height: 64, borderRadius: 16, margin: '0 auto 22px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: 'linear-gradient(135deg, var(--accent) 0%, #3b82f6 100%)',
                    boxShadow: 'var(--accent-glow)',
                }}>
                    <Lock size={28} color="#fff" />
                </div>

                <h2 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 700, color: 'var(--text)' }}>
                    {f.title}
                </h2>
                <p style={{ margin: '0 0 22px', color: 'var(--text-secondary)', fontSize: 14.5, lineHeight: 1.5 }}>
                    {f.line} <br />Réservé aux offres payantes.
                </p>

                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 26px', textAlign: 'left', display: 'inline-block' }}>
                    {f.perks.map((p, i) => (
                        <li key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(--text)', fontSize: 14, marginBottom: 10 }}>
                            <Sparkles size={15} style={{ color: 'var(--accent)', flexShrink: 0 }} /> {p}
                        </li>
                    ))}
                </ul>

                <button
                    onClick={onUpgrade}
                    style={{
                        width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                        background: 'linear-gradient(135deg, var(--accent) 0%, #3b82f6 100%)',
                        color: '#fff', border: 'none', borderRadius: 11, padding: '13px 24px',
                        fontSize: 15, fontWeight: 600, cursor: 'pointer', boxShadow: 'var(--accent-glow)',
                    }}
                >
                    Découvrir les offres <ArrowRight size={17} />
                </button>
            </div>
        </div>
    );
}
